import Vue from 'vue';
import Vuex from 'vuex';
import auth from './modules/auth';
import motor from './modules/motor';
import travel from './modules/travel';
import home from './modules/home';
import driver from './modules/driver';
import hunter from './modules/hunter';
import offer from './modules/offer';
import contract from './modules/contract';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    motor,
    travel,
    home,
    driver,
    hunter,
    offer,
    contract
  }
});
